export const READ_ONLY_TOKENS_MESSAGE =
  "Your account is read-only, so you can't view or generate tokens. Ask a tenant admin to remove read-only access.";
